export type ThemeMode = "system" | "light" | "dark";

export function resolvesToDark(
  mode: ThemeMode,
  prefersDark: boolean,
): boolean {
  return mode === "dark" || (mode === "system" && prefersDark);
}
